import { defaultPagination } from "app/redux/initialState";
import { ISprints, SprintState } from "../../Sprints/types";

export const defaultSprintFormData: ISprints = {
  name: {
    name: "",
    error: "",
  },
  description: "",
  projectId: "",
  scrumMasterId: "",
  sprintMembers: [],
  startDate: "",
  endDate: "",
  sendRetrospectiveRequest: true,
  selectedSprint: "",
};

export const initialState: SprintState = {
  loading: false,
  buttonLoading: false,
  mainLoading: false, // loading when loading row data
  customizeHeader: [],
  list: [],
  pagination: { ...defaultPagination },
  formData: { ...defaultSprintFormData },
  completedSprintList: [],
  filters: { statusFilter: [], startDate: "", endDate: "", search: "" },
  settingDrawerOpen: false,
  sprintDetailDrawer: false,
  selectedSprintId: ""
};
